import DTO from './DTO';

class ProviderDTO extends DTO {
  provider_name;

  token;

  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'provider_name',
        type: String,
        validators: [],
        labelKey: 'name',
      },
      {
        name: 'provider_id',
        type: String,
        validators: [],
        labelKey: 'provider_id',
      },
      {
        name: 'token',
        type: String,
        validators: [],
        labelKey: 'provider.token',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      provider_name: this.provider_name,
      token: this.token,
    };
  }
}

export default ProviderDTO;
